export default __webpack_public_path__ + "static/media/g1.3ccb37f8.jpg";